import * as React from "react";
import {BsArrowRight} from "@react-icons/all-files/bs/BsArrowRight";
import {BsArrowDown} from "@react-icons/all-files/bs/BsArrowDown";
import {Trans} from "react-i18next";
import {Link} from "gatsby-plugin-react-i18next";
import {Post} from "../../types/Post";
import {PostImage} from "../../components/PostImage";

interface LatestPostsProps {
	posts: {
		node: Post,
	}[];
}

const LatestPosts: React.FC<LatestPostsProps> = (props) => {
	return (
		<div className="w-full latest-bg">
			<div className="max-w-6xl mx-auto px-6 py-10">
				<h1 className="text-white text-2xl pb-2 text-center uppercase font-bold">
					<Trans>Posts</Trans>
				</h1>
				<p className="max-w-2xl mx-auto text-center font-normal text-sm text-white pb-8">
					<Trans>Latest posts</Trans>
				</p>
				<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
					{props.posts.map((postEdge, index) => {
						const post = postEdge.node;
						return (
							<div key={index}>

								<PostImage
									post={post}
								/>
								<div className="bg-white py-4 px-4 rounded-b-md">
									<h2 className="text-lg text-center text-blueish pb-8 font-semibold">
										{post.frontmatter.title}
									</h2>
									<div className="flex justify-center">
										<Link to={`/posts/${post.frontmatter.slug}`}>
											<div
												className="flex justify-center w-44 bg-blueish  rounded-md cursor-pointer transition-all py-2.5 hover:bg-blakish">
												<div className="text-white text-base font-semibold">
													<Trans>Read more</Trans>
												</div>
												<span className="flex self-center">
                          <BsArrowRight className="text-white text-2xl ml-1"/>
                        </span>
											</div>
										</Link>
									</div>
								</div>
							</div>
						);
					})}
				</div>
				<div className="flex justify-center mt-8">
					<div className="cursor-pointer">
						<Link to='/posts' className="text-base font-semibold text-white">
							<Trans>View More</Trans>
							<div className="flex justify-center">
								<div className=" bg-blueish rounded-full w-7 h-7 flex justify-center mt-1">
									<BsArrowDown className="text-2xl text-white text-center mt-0.5"/>
								</div>
							</div>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LatestPosts;
